module.exports = "<div widgetHandle>DRAG ME</div>\n\n<p>\n  my custom widget <b>works</b>!\n</p>\n<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-widget/my-widget.component.html
// module id = 295
// module chunks = 0